export var calculateRgba = function (color, opacity) {
    if (color[0] === "#") {
        color = color.slice(1);
    }
    if (color.length === 3) {
        var res_1 = "";
        color.split("").forEach(function (c) {
            res_1 += c;
            res_1 += c;
        });
        color = res_1;
    }
    var rgbValues = color
        .match(/.{2}/g)
        .map(function (hex) { return parseInt(hex, 16); })
        .join(", ");
    return "rgba(" + rgbValues + ", " + opacity + ")";
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-spinners/dist/helpers/colors.js
// module id = 835
// module chunks = 0